<template>
  <div class="change-issue-status-button"
       @click="markAsFixedUnfixedIssue">
    {{$t(markButtonCaption)}}
  </div>
</template>

<script>
import { ISSUE_STATUSES } from '@/constants/issues';
import { CHANGE_ISSUE_STATUS } from '@/store/issue/actionTypes';

export default {
  name: 'ChangeIssueStatusButton',
  props: {
    issue: {
      type: Object,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  computed: {
    markButtonCaption() {
      return this.issue.status === ISSUE_STATUSES.FOUND
        ? 'projectDetails.issues.markAsFixed' : 'projectDetails.issues.markAsUnFixed';
    },
  },
  methods: {
    async markAsFixedUnfixedIssue() {
      const newStatus = this.issue.status === ISSUE_STATUSES.FOUND ? ISSUE_STATUSES.FIXED : ISSUE_STATUSES.FOUND;
      const options = { status: newStatus, issueId: this.issue.id, projectId: this.projectId };
      const data = await this.$store.dispatch(CHANGE_ISSUE_STATUS, options);
      this.$emit('issueStatusChanged', data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.change-issue-status-button {
  cursor: pointer;
  padding-top: rem(5);
  position: relative;
  right: rem(35);
  text-transform: uppercase;
  color: #4D9FEB;
  font-size: $font-size-sm;
  font-weight: 500;
  letter-spacing: rem(1.07);
  line-height: rem(16);
  text-align: center;
  box-sizing: border-box;
  height: rem(28);
  width: rem(131);
  border: $border-width-thin solid #4D9FEB;
  border-radius: $radius-sm;
  background-color: var(--bg-primary);
  box-shadow: 0 rem(1) rem(1) 0 rgba(0,0,0,0.14), 0 rem(2) rem(1) rem(-1) rgba(0,0,0,0.12), 0 rem(1) rem(3) 0 rgba(0,0,0,0.2);
}
</style>
